import React from "react";
import { Route, Redirect } from "react-router-dom";
import { Layout } from "antd";
import CostumeHeader from "../header/index";
import UseWindowResize from '../../utilities/UseWindowResize';
const { Content } = Layout;

const ProtectedRoute = (props) => {
  const [width] = UseWindowResize();
  const { component: Component, ...rest } = props;

  const admin = () => {
    if (localStorage.getItem("oddruN@2021%")) {
      const message = JSON.parse(localStorage.getItem("oddruN@2021%")).message;
      if (message === "SUCCESS") {
        return 1;
      } else {
        return 0;
      }
    }
  };

  return rest.parentCallBack ? (
    <Route
      exact
      path={rest.path}
      render={(props) =>
        admin() ? (
          <React.Fragment>
            <Layout className="layout">
              <CostumeHeader />
              <Content style={width>575?{ padding: "0 50px" }:{padding:0}} className="mainContent">
                <Component
                  {...props}
                  parentCallBack={rest.parentCallBack}
                  setCanBlock={rest.setCanBlock}
                />
              </Content>
            </Layout>
          </React.Fragment>
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  ) : (
    <Route
      {...rest}
      render={(props) =>
        admin() ? (
          <React.Fragment>
            <Layout className="layout">
              <CostumeHeader />
              <Content style={width>575?{ padding: "0 50px" }:{padding:0}} className="mainContent">
                <Component {...props} />
              </Content>
            </Layout>
          </React.Fragment>
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

export default ProtectedRoute;
